import { Typography } from "@mui/material";
import { BaseStyledButton } from "./shared/ButtonStyles";

interface ImageButtonProps {
  image: React.ReactNode;
  label: string;
  onClick?: () => void;
  selected?: boolean;
  subText?: string;
  disabled?: boolean;
}

export function ImageButton({ image, label, onClick, selected, subText, disabled = false }: ImageButtonProps) {
  return (
    <BaseStyledButton onClick={onClick} variant={selected ? "contained" : "outlined"} disabled={disabled}>
      {image}
      <Typography className="button-label" variant="body1">
        {label}
      </Typography>
      {subText && (
        <Typography className="button-subtext" variant="body2">
          {subText}
        </Typography>
      )}
    </BaseStyledButton>
  );
}
